/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Why_1_TInputs */

const en_cp_why_1_t = /** @type {(inputs: Cp_Why_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criteria before code`)
};

const id_cp_why_1_t = /** @type {(inputs: Cp_Why_1_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kriteria sebelum kode`)
};

/**
* | output |
* | --- |
* | "Criteria before code" |
*
* @param {Cp_Why_1_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_why_1_t = /** @type {((inputs?: Cp_Why_1_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Why_1_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_why_1_t(inputs)
	return en_cp_why_1_t(inputs)
});